const MODULE_NAME = 'QuestionsModule';

export const GET_TASK_QUESTIONS = `${MODULE_NAME}/GET_TASK_QUESTIONS`;
export const GET_QUESTION = `${MODULE_NAME}/GET_QUESTION`;
export const FETCH_QUESTION_LABEL = `${MODULE_NAME}/FETCH_QUESTION_LABEL`;
